;(function(win) {
  var US_API_BASE = 'https://us-api-jiyin.hannto.com';

  function resolveApiBase(mode) {
    var U = win.CommunityUtils;
    if (!U) return US_API_BASE;
    if (mode === 'serviceCode') return U.getApiBaseUrl('serviceCode');
    if (typeof U.getApiBaseUrl === 'function') return U.getApiBaseUrl();
    return US_API_BASE;
  }

  function create(options) {
    var opts = options || {};

    function baseHeaders(extra) {
      var lang = win.CommunityUtils ? CommunityUtils.getLanguage() : 'en';
      var headers = {
        'Content-Type': 'application/json',
        'LANGUAGE': win.CommunityUtils ? CommunityUtils.toLanguageHeader(lang) : 'en'
      };
      if (extra) Object.assign(headers, extra);
      return headers;
    }

    function pcClientTypeHeaders(extra) {
      var headers = extra ? Object.assign({}, extra) : {};
      var U = win.CommunityUtils;
      if (U && typeof U.isPcDevice === 'function' && U.isPcDevice()) {
        headers['CLIENT-TYPE'] = 'CREATIVERSE';
      }
      return Object.keys(headers).length ? headers : undefined;
    }

    var signatureQueue = Promise.resolve();
    function queuedGetSignature(payload) {
      var p = signatureQueue.then(function() {
        return win.HanntoJsBridge.getSignature(payload);
      });
      signatureQueue = p.catch(function() {});
      return p;
    }

    function signedFetch(url, method, body, signUrl, fetchOpts) {
      method = method || 'GET';
      fetchOpts = fetchOpts || {};
      var headers = {};
      function run(h) {
        var options = { method: method, headers: h };
        if (body != null) options.body = JSON.stringify(body);
        return fetch(url, options).then(function(res) { return res.json(); });
      }
      if (win.HanntoJsBridge && typeof win.HanntoJsBridge.getSignature === 'function') {
        return queuedGetSignature({ url: signUrl || url, method: method })
          .then(function(res) {
            if (res && res.data) {
              Object.assign(headers, res.data);
              if (fetchOpts.dropDeviceType) delete headers['X-Client-Device-Type'];
            }
            return run(headers);
          })
          .catch(function() { return run(headers); });
      }
      return run(headers);
    }

    function request(path, params, headerExtra, apiBase) {
      var ready = (win.CommunityUtils && typeof CommunityUtils.whenApiRegionReady === 'function')
        ? CommunityUtils.whenApiRegionReady()
        : Promise.resolve();
      return ready.then(function() {
        var query = new URLSearchParams(params || {}).toString();
        var api = apiBase || resolveApiBase(opts.apiBaseMode);
        var url = api + path + (query ? ('?' + query) : '');
        return fetch(url, {
          method: 'GET',
          headers: baseHeaders(headerExtra)
        }).then(function(res) { return res.json(); });
      });
    }

    return {
      getHottest: function(options) {
        var opts = options || {};
        return request('/v1/m/res_mgr/home_page/hottest/', {
          type: opts.type == null ? 4 : opts.type,
          page: opts.page || 1,
          size: opts.size || 12
        });
      },
      getTabInfo: function() {
        return request('/v1/m/res_mgr/perilla_home_page_v2/tab_info/', {}, pcClientTypeHeaders({ 'PERMISSION-CLIENT-VERSION': '2.2' }));
      },
      getTabDetail: function(options) {
        var opts = options || {};
        return request('/v1/m/res_mgr/perilla_home_page_v2/tab_detail/', {
          category_id: opts.categoryId || '',
          source_type: opts.sourceType == null ? 3 : opts.sourceType,
          page: opts.page || 1,
          size: opts.size || 60
        }, pcClientTypeHeaders());
      },
      getResourceCategory: function(resourceType) {
        return request('/v1/m/res_mgr/perilla_resource/category/', {
          resource_type: resourceType || 1
        }, pcClientTypeHeaders());
      },
      getPerillaResource: function(options) {
        var params = options || {};
        var query = {
          category: params.category || 'all',
          label: params.label || 'all',
          source_type: params.sourceType == null ? 1 : params.sourceType,
          sort_type: params.sortType == null ? 1 : params.sortType,
          page: params.page || 1,
          size: params.size || 60
        };
        return request('/content_platform_resource/c/perilla_resource/', query).then(function(res) {
          if (res && res.code === '0' && res.result && Array.isArray(res.result.list)) return res;
        });
      },
      getPerillaResourceDetail: function(options) {
        var params = options || {};
        var id = params.id || '';
        if (!id) return Promise.resolve({ detail: {}, recommend: { data: [] } });
        return request('/v1/c/res/web/perilla_resource/' + id + '/?scene=1', null, pcClientTypeHeaders()).then(function(res) {
          if (res && (res.request_id || (res.code === '0' && res.result))) return res;
        });
      },
      searchResource: function(options) {
        var opts = options || {};
        return request('/v1/m/res_mgr/home_page/search/', {
          type: opts.type == null ? 4 : opts.type,
          query_terms: opts.queryTerms || opts.keyword || '',
          page: opts.page || 1,
          size: opts.size || 60
        }, pcClientTypeHeaders());
      },
      getWorldCupMatches: function() {
        return request('/content_platform_resource/c/world_cup/matches', null, null, US_API_BASE);
      },
      getPcBannerConfigs: function(options) {
        var opts = options || {};
        var port = opts.port || 'WEB';
        var page = opts.page || 1;
        var size = opts.size || 20;
        function fetchWithPrinter(printer) {
          return request('/v2/c/content_platform_resource/pc_banner_configs/', {
            port: port,
            printer: printer || 'all',
            page: page,
            size: size
          });
        }
        if (port === 'WEB' && win.HanntoJsBridge && typeof win.HanntoJsBridge.getDeviceInfo === 'function') {
          return win.HanntoJsBridge.getDeviceInfo({})
            .then(function(res) {
              var list = (res && res.data) || [];
              var model = list[0] && list[0].model;
              var printer = model ? String(model).split('.')[2] : 'all';
              return fetchWithPrinter(printer || 'all');
            })
            .catch(function() { return fetchWithPrinter('all'); });
        }
        return fetchWithPrinter('all');
      },
      getSummerActivityStatus: function(options) {
        var opts = options || {};
        var machineModel = opts.machineModel || 'laurel';
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/activity/summer/status';
        var path = signPath + '?machine_model=' + encodeURIComponent(machineModel);
        return signedFetch(apiBase + path, 'GET', null, signPath, { dropDeviceType: true });
      },
      registerSummerActivity: function(options) {
        var opts = options || {};
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var payload = opts.payload || {};
        var path = '/content_platform_resource/c/activity/summer/register';
        return signedFetch(apiBase + path, 'POST', payload, path, { dropDeviceType: true });
      },
      getSummerPointsSignup: function(options) {
        var opts = options || {};
        var machineModel = opts.machineModel || 'laurel';
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/activity/summer-points/signup';
        var path = signPath + '?machine_model=' + encodeURIComponent(machineModel);
        return signedFetch(apiBase + path, 'GET', null, signPath, { dropDeviceType: true });
      },
      registerSummerPoints: function(options) {
        var opts = options || {};
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var payload = opts.payload || {};
        var path = '/content_platform_resource/c/activity/summer-points/signup';
        return signedFetch(apiBase + path, 'POST', payload, path, { dropDeviceType: true });
      },
      updateSummerPointsSignup: function(options) {
        var opts = options || {};
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var payload = opts.payload || {};
        var path = '/content_platform_resource/c/activity/summer-points/signup';
        return signedFetch(apiBase + path, 'PUT', payload, path, { dropDeviceType: true });
      },
      getSummerPointsTasks: function(options) {
        var opts = options || {};
        var machineModel = opts.machineModel || 'laurel';
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/activity/summer-points/tasks';
        var path = signPath + '?machine_model=' + encodeURIComponent(machineModel);
        return signedFetch(apiBase + path, 'GET', null, signPath, { dropDeviceType: true });
      },
      completeSummerPointsTask: function(options) {
        var opts = options || {};
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var payload = opts.payload || {};
        var path = '/content_platform_resource/c/activity/summer-points/tasks/complete';
        return signedFetch(apiBase + path, 'POST', payload, path, { dropDeviceType: true });
      },
      getSummerPointsRanking: function(options) {
        var opts = options || {};
        var machineModel = opts.machineModel || 'laurel';
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/activity/summer-points/ranking';
        var path = signPath + '?machine_model=' + encodeURIComponent(machineModel);
        return signedFetch(apiBase + path, 'GET', null, signPath, { dropDeviceType: true });
      },
      getSummerPointsStatus: function(options) {
        return this.getSummerPointsSignup(options);
      },
      getSummerPuzzleList: function(options) {
        var opts = options || {};
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        return request('/content_platform_resource/c/photo_collages', {
          page: opts.page || 1,
          size: opts.size || 20
        }, null, apiBase);
      },
      getSummerRecipeList: function(options) {
        var opts = options || {};
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var params = {
          device_model: opts.deviceModel || opts.machineModel || 'laurel',
          page: opts.page || 1,
          size: opts.size || 20
        };
        if (opts.sizeCategory) params.size_category = opts.sizeCategory;
        return request('/content_platform_resource/c/photo_recipes/system', params, { LANGUAGE: 'en' }, apiBase);
      },
      getPhotoRecipeShareDetail: function(options) {
        var opts = options || {};
        var shareId = String(opts.shareId || opts.id || '').trim();
        if (!shareId) return Promise.resolve(null);
        var serviceCode = opts.serviceCode != null ? opts.serviceCode : '0';
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', serviceCode);
        return request(
          '/content_platform_resource/c/photo_recipes/share/' + encodeURIComponent(shareId),
          null,
          { LANGUAGE: 'en' },
          apiBase
        );
      },
      getBackToSchoolCode: function() {
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/backtoschool/code';
        return signedFetch(apiBase + signPath, 'GET', null, signPath, { dropDeviceType: true });
      },
      claimBackToSchoolCode: function() {
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/backtoschool/code';
        return signedFetch(apiBase + signPath, 'POST', {}, signPath, { dropDeviceType: true });
      },
      getUserAccompanyDays: function() {
        var apiBase = CommunityUtils.getApiBaseUrl('serviceCode', '0');
        var signPath = '/content_platform_resource/c/user/accompany_days';
        return signedFetch(apiBase + signPath, 'GET', null, signPath, { dropDeviceType: true });
      }
    };
  }

  win.CommunityRequest = { create: create };
})(window);
